<template>
  <div class="live-feed-container">
    <LiveFeedEntry v-if="alerts.length" type="alerts" :feed="alertsContent" />
    <LiveFeedEntry
      v-if="notices.length"
      type="notices"
      :feed="noticesContent"
    />
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import LiveFeedEntry from '@/components/LiveFeedEntry.vue'
import { useAlertStore } from '@/stores/useAlertStore'
import { useNoticeStore } from '@/stores/useNoticeStore'

const storeAlerts = useAlertStore()
const storeNotice = useNoticeStore()

const { alerts } = storeToRefs(storeAlerts)
const { notices } = storeToRefs(storeNotice)

const alertsContent = computed(() => alerts.value.map(alert => alert.content))

const noticesContent = computed(() =>
  notices.value.map(notice => notice.content)
)
</script>
<style lang="scss" scoped>
.live-feed-container {
  position: relative;
  width: 100%;
  height: vh(355px);
  padding: 0 vw(170px);
  margin-top: vh(48px);
  margin-bottom: vh(10px);
  overflow: hidden;
}
</style>
